export enum MeetingLogType {
    ClientJoined = 0,
    OrganizerJoined = 1,
    CustomMessage = 2,
}
